jQuery(function ($) {
  $(".header__icon").on("click", function () {
    $(".gm-bb-menu-container.gm-bb-mobile.mobile-top").toggleClass("show-menu");
    $("html").toggleClass("overflow-hidden");
  });
  $(".faq-item").on("click", function () {
    $(this).toggleClass("open");
    $(this).find(".desc").slideToggle("fast");
  });

  $(".edu-hub-section .edu-item-wrap").slick({
    dots: false,
    arrows: false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 2500,
        settings: "unslick",
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          infinite: false,
        },
      },
      {
        breakpoint: 639,
        settings: {
          slidesToShow: 1,
          infinite: false,
        },
      },
    ],
  });

  jQuery(".header--has-menu").on(
    "mouseenter",
    ".gm-has-submenu.gm-submenu-aliexpress > .gm-target",
    function () {
      let currentTarget = jQuery(this);
      setTimeout(function () {
        currentTarget
          .closest(".gm-submenu-aliexpress")
          .find(".gm-has-submenu.menu-tablet-lists")
          .first()
          .addClass("gm-active");
        currentTarget
          .closest(".gm-submenu-aliexpress")
          .find(".gm-tab-contents .gm-tab-content")
          .first()
          .addClass("gm-active");
      }, 300);
    }
  );
});

if (document.querySelector(".js-related-items")) {
  new Splide(".js-related-items", {
    type: "slide",
    drag: "free",
    snap: true,
    perPage: 1,
    autoplay: true,
    arrows: false,
    pagination: false,
    mediaQuery: "min",
    padding: { right: '20%' },
    gap: "1.6rem",
    breakpoints: {
      640: {
        perPage: 2,
      },
      800: {
        perPage: 3,
      },
      1200: {
        destroy: true,
      },
    },
  }).mount();
}
